export default __webpack_public_path__ + "static/media/Ballroll_00203.9fc797b3.png";